<wiz-hgroup
  height="100%"
  width="100%"
  gap="2"
  verticalAlign="center"
  style="padding: 5px"
  [wizDisabled]="owner.wizDisabled"
>
  <wiz-vgroup
    width="30px"
    height="100%"
    style="padding: 5px"
    verticalAlign="space-between"
    horizontalAlign="center"
    class="section-container"
  >

  <wiz-icon [visible]="mayUp()" (click)="doUp($event)">arrow-up</wiz-icon>
  <wiz-icon [visible]="mayDown()" (click)="doDown($event)">arrow-down</wiz-icon>
  <wiz-icon [visible]="mayDelete()" (click)="doDelete($event)">delete</wiz-icon>

  </wiz-vgroup>

  <wiz-hgroup #vgEdition wizValidationContainer width="100%" height="100%" class="section-container" padding="5px">
    <wiz-dropdown
      #ddlComparator
      [wizDataProvider]="comparatorDS"
      [wizMandatory]="true"
      (click)="focusMeImFamous($event)"
      [wizLabelField]="'fulltrsLabel'"
      [wizLabel]="'$.style.comparator.$'"
      width="200px"
    ></wiz-dropdown>

    <wiz-group width="350px" height="80px">
      <wiz-text-area
        #taFormula
        [wizLabel]="'$.style.formula.$'"
        (click)="focusMeImFamous($event)"
        [wizMandatory]="true"
        [wizShowErrors]="true"
        width="100%"
        height="80px"
        [wizValue]="formula"
        [wizValidator]="formulaValidator()"
      ></wiz-text-area>

      <wiz-hgroup width="100%" style="padding: 2px" horizontalAlign="end">
        <wiz-icon (click)="showFormulaEditor()">formula</wiz-icon>
      </wiz-hgroup>
    </wiz-group>
  </wiz-hgroup>

  <wiz-vgroup
    verticalAlign="center"
    width="160px"
    height="100%"
    verticalAlign="center"
    class="section-container"
    padding="5px"
  >
    <wiz-hgroup width="100%">
      <span
        #blockFont
        [style.backgroundColor]="fontColor"
        style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
        width="20px"
        height="20px"
        (click)="showColorPicker($event)"
      ></span>
        <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('blockFont')">removal</wiz-icon>
        <wiz-label wizLabel="$.style.css.fontcolor.$" style="font-size: 11px"></wiz-label>
      </wiz-hgroup>
      <wiz-hgroup width="100%">
        <span
        #blockBack
        [style.backgroundColor]="backgroundColor"
        width="20px"
        height="20px"
        (click)="showColorPicker($event)"
        style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
      ></span>
        <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('blockBack')">removal</wiz-icon>
        <wiz-label wizLabel="$.style.css.backgroundcolor.$" style="font-size: 11px"></wiz-label>
      </wiz-hgroup>     
    <wiz-checkbox #cbBold wizLabel="$.style.css.bold.$" [wizChecked]="bold" (wizClick)="swapBold($event)"></wiz-checkbox>
  </wiz-vgroup>
</wiz-hgroup>
